import React, {useState} from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  createTemplateAsk
} from "../../store/actions/ask/templates";
import {
  displayWarningToast,
  displayErrorToast
} from "../../store/actions/overflowNotification";
import { createSurveyAsk } from "../../store/actions/ask/surveys";
import {
  createDraftAsk,
  deleteDraftAsk
} from "../../store/actions/ask/drafts";
import { getCommunityTemplatesList } from "../../store/actions/ask";
import { checkDuplicate } from "../../libs/utils";
import { FormattedMessage } from "react-intl";
import AskEditPage from "../../components/ask/edit";
import Page from "../../components/general/page";

const AskEditView = ({ pageRef}) => {
  const [result, setResult] = useState(null);

  const main = useSelector(state => state.main);
  const accountantUuidSelected = main.accountantUuidSelected;
  const myType = main.myType;

  const dispatch = useDispatch();

  const createSurveyFunc = (
    templateId, recipients, template, draftId, isShared
  ) => {
    switch (true) {
    
    case recipients.length === 0 && isShared :
      if (window.aptrinsic) {
        window.aptrinsic("track", "digital-box:ASK-NEW PUBLIC TEMPLATE");
      }
      setResult(1);
      break;

    case templateId !== null && templateId !== undefined && (typeof templateId === "string" && templateId.length > 0):
      dispatch(createSurveyAsk({
        templateId: templateId,
        managerId: accountantUuidSelected,
        itemIds: recipients
      }))
        .then(() => {
          if (draftId) {
            dispatch(deleteDraftAsk(draftId))
              .then(() => {
                if (window.aptrinsic) {
                  window.aptrinsic("track", "digital-box:ASK-NEW REQUEST");
                }
                setResult(2);
              })
              .catch(() => {
                dispatch(displayErrorToast("Si è verificato un errore durante la cancellazione della bozza",
                  "Errore"));
              });
          } else {
            if (window.aptrinsic) {
              window.aptrinsic("track", "digital-box:ASK-NEW REQUEST");
            }
            setResult(2);
          }
        })
        .catch(() => {
          dispatch(displayErrorToast("Si è verificato un errore durante la creazione della survey",
            "Errore"));
        });
      break;

    default:
      dispatch(createSurveyAsk({
        template: template,
        managerId: accountantUuidSelected,
        itemIds: recipients
      }))
        .then(() => {
          if (draftId) {
            dispatch(deleteDraftAsk(draftId))
              .then(() => {
                if (window.aptrinsic) {
                  window.aptrinsic("track", "digital-box:ASK-NEW REQUEST");
                }
                setResult(2);
              })
              .catch(err => {
                dispatch(displayErrorToast("Si è verificato un errore durante la cancellazione della bozza",
                  "Errore"));
              });
          } else {
            if (window.aptrinsic) {
              window.aptrinsic("track", "digital-box:ASK-NEW REQUEST");
            }
            setResult(2);
          }
        })
        .catch(() => {
          dispatch(displayErrorToast("Si è verificato un errore durante la creazione della survey",
            "Errore"));
        });
    }
  };

  const onSave = (
    items,
    templateId,
    title,
    recipients,
    isPublic,
    isShared,
    isDraft,
    draftId,
    category,
    isForDots
  ) => {

    let errDuplicates = false;
    const newItems = [];
    items.map(item => {
      let format = item.format;
      let type = item.type;
      switch (type) {
      case "date":
        type = "input";
        break;
      case "number":
        type = "input";
        break;
      case "currency":
        type = "input";
        break;
      default:
        break;
      }
      if (item.choices && item.choices.length === 0) {
        newItems.push({
          type: type,
          format: format,
          isRequired: item.isRequired,
          label: item.label,
          hint: item.hint && item.hint !== "" ? item.hint : null
        });
      } else {
        if (item.choices && checkDuplicate(item.choices)) {
          errDuplicates = true;
        }
        newItems.push({
          type: type,
          format: format,
          isRequired: item.isRequired,
          label: item.label,
          hint: item.hint,
          choices: item.choices
        });
      }
      return newItems;
    });
    if (errDuplicates) {
      dispatch(displayWarningToast("Controllare che le risposte con valori multipli o singoli siano univoche",
        "NB"));
      return;
    }
    if (isDraft) {
      dispatch(createDraftAsk(draftId,
        {
          template: {
            title: title,
            managerId: accountantUuidSelected,
            items: newItems,
            availableTo: isShared && isPublic ? "managed" : "owner",
            categoryId: category
          },
          managerId: accountantUuidSelected,
          itemIds: recipients
        }))
        .then(() => {
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:ASK-NEW DRAFT");
          }
          setResult(2);
        })
        .catch(() => {
          newItems.length === 1 && newItems[0].label === ""
            ? dispatch(displayErrorToast("Inserire almeno una domanda",
              "Errore"))
            : dispatch(displayErrorToast("Si è verificato un errore durante il salvataggio della bozza",
              "Errore"));
        });
    } else if (!templateId) {
      if (draftId) {
        if (isShared || isForDots) {
          dispatch(createTemplateAsk({
            title: title,
            managerId: accountantUuidSelected,
            items: newItems,
            availableTo: isShared && isPublic ? "managed" : "owner",
            categoryId: category,
            publishToDots: isForDots
          }))
            .then(res => {
              createSurveyFunc(
                res.id, recipients, null, draftId, isShared
              );
              dispatch(getCommunityTemplatesList());
            })
            .catch(err => {
              dispatch(displayErrorToast("Si è verificato un errore durante la creazione del template",
                "Errore"));
            });
        } else {
          createSurveyFunc(
            null,
            recipients,
            {
              title: title,
              items: newItems,
              categoryId: category
            },
            draftId,
            isShared
          );
        }
      } else if (isShared) {
        dispatch(createTemplateAsk({
          title: title,
          managerId: accountantUuidSelected,
          items: newItems,
          availableTo: isShared && isPublic ? "managed" : "owner",
          categoryId: category,
          publishToDots: isForDots
        }))
          .then(res => {
            createSurveyFunc(
              res.id, recipients, null, null, isShared
            );
            dispatch(getCommunityTemplatesList());
          })
          .catch(() => {
            dispatch(displayErrorToast("Si è verificato un errore durante la creazione del template",
              "Errore"));
          });
      } else {
        createSurveyFunc(
          null,
          recipients,
          {
            title: title,
            items: newItems,
            categoryId: category
          },
          null,
          isShared
        );
      }
    } else {
      createSurveyFunc(
        templateId, recipients, null, null, isShared
      );
    }
  };

  return (
    <Page
      pageRef={pageRef}
      className={"contentStructure transparent settings"}
      title={<FormattedMessage id="ask.pages.edit.title" />}
      subtitle={
        myType !== "STUDIO" ? (
          <FormattedMessage id="ask.pages.list.subtitle" />
        ) : (
          ""
        )
      }      
      backText={<FormattedMessage id="ask.pages.edit.back" />}
      backUrl="/ask-list"
    >
      <AskEditPage
        pageRef={pageRef}
        saveAsk={onSave}
        result={result}        
      />
    </Page>
  );
};

export default AskEditView;

